const $$splitComponentImporter = () => import('/data/circle/current/app/javascript/react/tanstack_routes/_protected/admin/audience/$sqid/$.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute, redirect } from "@tanstack/react-router";
export const Route = createFileRoute("/_protected/admin/audience/$sqid/$")({
  beforeLoad: ({
    location
  }) => {
    redirect({
      // Preserve the legacy nested path suffix, query, and hash while
      // redirecting into the new settings namespace.
      href: location.href.replace("/admin/audience", "/settings/admin/audience"),
      replace: true,
      state: location.state,
      throw: true
    });
  },
  component: lazyRouteComponent($$splitComponentImporter, 'component')
});